export default __webpack_public_path__ + "static/media/Knockout-30.8816879b.otf";